<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { slide, fly } from "svelte/transition";
  import Link from "./Link.svelte";
  export let request_store_key: StoresKey;
  const { nav_menus, site_page, reverse_router, i18nOf, T, locale } =
    getStoresContext(request_store_key);
  let isOpen: boolean = false;
  let rest: NavigationMenuItem[];
  let current: string;
  let currentPageTitle = "";

  $: {
    current = $site_page?.friendlyUrlPath;
    currentPageTitle = $site_page ? i18nOf($site_page.title_i18n) : "";
    let primaryNav = $nav_menus.find((nav) => nav.navigationType == "Primary");
    let secondaryNavs = primaryNav
      ? primaryNav.navigationMenuItems.filter(
          (nav) => nav.navigationMenuItems.length
        )
      : [];
    let submenu;
    if (secondaryNavs) {
      secondaryNavs.forEach((secondaryNavItem) => {
        secondaryNavItem.navigationMenuItems.find((nav) => nav.link == current);
        submenu = secondaryNavItem;
      });
    }
    [...rest] = submenu ? submenu.navigationMenuItems : [];
  }
  $: t = $T;
</script>

<div class="menu-list col-12 d-none d-sm-block mb-5">
  <div class="d-flex flex-wrap">
    {#each rest.filter((item) => !item.excluded_locales?.some((x) => x == $locale)) as item}
      <Link {item} {request_store_key} />
    {/each}
  </div>
</div>

<div
  class={isOpen
    ? "open-dropdown menu-dropdown col-12 d-sm-none mb-4"
    : "menu-dropdown col-12 d-sm-none mb-4"}>
  <button
    class="col-12 dropdown-mob-text"
    on:click={() => {
      isOpen = !isOpen;
    }}>
    <div class="text-dropdown">
      {t`navigation`}:
      <span class="current-page-text">{currentPageTitle}</span>
    </div>
    {#if isOpen}
      <img
        class="d-inline-block mr-2 arrow-open"
        src="/theme/citycon2023/images/down-arrow.png"
        width="30"
        alt="down-arrow" />
    {:else}
      <img
        class="d-inline-block mr-2"
        src="/theme/citycon2023/images/down-arrow.png"
        width="30"
        alt="down-arrow" />
    {/if}
  </button>
  {#if isOpen}
    <div class="dropdown" transition:slide|local>
      <div
        class="col-12 nav-item-mob-container"
        transition:fly={{ y: -200, duration: 800 }}>
        <div class="py-3">
          {#each rest.filter((item) => !item.excluded_locales?.some((x) => x == $locale)) as item}
            {#if item.type == "url"}
              {#if item.availableLanguages.includes($locale)}
                <a
                  href={item.url}
                  target="_blank"
                  class="nav-item-mob d-lg-inline d-block mb-4">
                  {i18nOf(item.name_i18n)}
                </a>
              {/if}
            {:else}
              <a
                href={$reverse_router.routePage(item.link)}
                class="nav-item-mob d-lg-inline d-block mb-4">
                {i18nOf(item.name_i18n)}
              </a>
            {/if}
          {/each}
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  .open-dropdown {
    top: 40px;
  }
  .dropdown {
    z-index: 1;
  }
  .arrow-open {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
  }
  .nav-item-mob-container {
    background-color: var(--color-black);
    .nav-item-mob {
      color: var(--color-white) !important;
      text-decoration: none !important;
      border-bottom: 1px solid var(--color-white);
      padding: 10px;
    }
  }
  .dropdown-mob-text {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    height: 55px;
    background-color: var(--color-black);
    border: none;
    .text-dropdown {
      font-size: 18px;
      line-height: 150%;
      color: var(--color-white);
    }
    .current-page-text {
      font-weight: bold;
    }
  }
</style>
